import i18n from '@/i18n';
import dayjs from 'dayjs';
// 默认查询参数
export const DEFAULT_FORM = {
  EChartsPieForm: {
    code: '',
    from: 'echart_category',
    items: [],
    selectValue: {}
  },
  EChartsBarForm: {
    dataIndex: '',
    coordRange_0: '',
    coordRange_1: '',
    Roi_time: '-24 hour',
    Roi_time_s: dayjs().subtract(24, 'hour').format('YYYY-MM-DD HH:mm:ss'),
    Roi_time_e: dayjs().format('YYYY-MM-DD HH:mm:ss'),
    type: 'count',
    items: {},
    target: ['temp']
  },
  RoiBrowserForm: {
    sorttype: 'desc',
    diysort: 'Roi_time',
    folder_sorttype: 'desc',
    folder_diysort: 'count',
    category_id: -100,
    dataType: 'file',
    folder_id: null,
    roi_index_code: null,
    roi_index_id: null,
    items: [],
    total: 0,
    is_show_empty_folder: false,
    reviewed_type: 1
  }
};

// 默认Tab
export const DEFAULT_TAB = () => {
  const ipp_role = localStorage.getItem('ipp_role');
  if (ipp_role === 'superadmin') {
    return [
      { label: i18n.t('ipp-view-detail.config.628021-0-1'), value: -7 },
      { label: i18n.t('ipp-view-detail.config.628021-0'), value: -1 },
      { label: i18n.t('ipp-view-detail.config.628021-1'), value: -2 },
      { label: i18n.t('ipp-view-detail.config.628021-2'), value: -3 },
      { label: i18n.t('ipp-view-detail.config.628021-3'), value: -100 },
      { label: i18n.t('ipp-view-detail.config.628021-4'), value: -5 },
      { label: i18n.t('ipp-view-detail.config.628021-5'), value: -4 }
    ];
  } else if (ipp_role === 'administrator') {
    return [
      { label: i18n.t('ipp-view-detail.config.628021-0-1'), value: -7 },
      { label: i18n.t('ipp-view-detail.config.628021-1'), value: -2 },
      { label: i18n.t('ipp-view-detail.config.628021-2'), value: -3 },
      { label: i18n.t('ipp-view-detail.config.628021-3'), value: -100 },
      { label: i18n.t('ipp-view-detail.config.628021-4'), value: -5 },
      { label: i18n.t('ipp-view-detail.config.628021-5'), value: -4 }
    ];
  } else {
    return [
      { label: i18n.t('ipp-view-detail.config.628021-1'), value: -2 },
      { label: i18n.t('ipp-view-detail.config.628021-2'), value: -3 },
      { label: i18n.t('ipp-view-detail.config.628021-3'), value: -100 },
      { label: i18n.t('ipp-view-detail.config.628021-4'), value: -5 },
      { label: i18n.t('ipp-view-detail.config.628021-5'), value: -4 }
    ];
  }
};

// 文件排序
export const FILE_SORT_LIST = [
  { value: 'Roi_time', label: i18n.t('ipp-view-detail.config.628021-6') },
  { value: 'size', label: i18n.t('ipp-view-detail.config.628021-7') },
  { value: 'ai', label: i18n.t('ipp-view-detail.config.628021-23') },
  { value: 'Roi_area', label: i18n.t('ipp-view-detail.config.628021-24') }
];

// 文件夹排序
export const FOLDER_SORT_LIST = [
  { value: 'count', label: i18n.t('ipp-view-detail.config.628021-8') },
  { value: 'interest', label: i18n.t('ipp-view-detail.config.628021-9') },
  { value: 'title', label: i18n.t('ipp-view-detail.config.628021-10') }
];

export const typeTab = [
  { code: 0, name: i18n.t('ipp-view-detail.config.628021-8'), unit: 'ROIs' },
  { code: 1, name: i18n.t('ipp-view-detail.config.628021-11'), unit: 'ROIs/L' },
  { code: 2, name: i18n.t('ipp-view-detail.config.628021-12'), unit: 'L' },
  { code: 3, name: i18n.t('ipp-view-detail.config.628021-13'), unit: 'MB' }
];

export const timeTab = [
  { code: '-24 hour', name: i18n.t('ipp-view-detail.config.628021-14') },
  { code: '-3 day', name: i18n.t('ipp-view-detail.config.628021-15') },
  { code: '-7 day', name: i18n.t('ipp-view-detail.config.628021-16') },
  { code: '-15 day', name: i18n.t('ipp-view-detail.config.628021-17') },
  { code: '-31 day', name: i18n.t('ipp-view-detail.config.628021-18') },
  { code: '-3 month', name: i18n.t('ipp-view-detail.config.628021-19') },
  { code: '-6  month', name: i18n.t('ipp-view-detail.config.628021-20') },
  { code: '-12 month', name: i18n.t('ipp-view-detail.config.628021-21') },
  { code: '-1', name: i18n.t('ipp-view-detail.config.628021-22') }
];
